import { v2rxDataOnCopyForBQ } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface ekaScribeOnCopyDataForBQ {
    prescriptionID: string;
    sessionID: string;
}

interface fnReturnType {
    success: boolean;
    message?: string;
}

export default async ({
    sessionID,
    prescriptionID,
}: ekaScribeOnCopyDataForBQ): Promise<fnReturnType> => {
    try {
        const res = await fetchWithRefresh(v2rxDataOnCopyForBQ, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ sessionID, prescriptionID }),
        });
        if (!res.ok) {
            return { success: false };
        }
        return { success: true };
    } catch (err) {
        return { success: false, message: String(err) };
    }
};
